import { render } from "./bill-by-sum.vue?vue&type=template&id=556180e0&scoped=true&ts=true"
import script from "./bill-by-sum.vue?vue&type=script&lang=ts"
export * from "./bill-by-sum.vue?vue&type=script&lang=ts"

import "./bill-by-sum.vue?vue&type=style&index=0&id=556180e0&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556180e0"]])

export default __exports__